import { render, staticRenderFns } from "./shareDiv.vue?vue&type=template&id=15964abf&"
import script from "./shareDiv.vue?vue&type=script&lang=ts&"
export * from "./shareDiv.vue?vue&type=script&lang=ts&"
import style0 from "./shareDiv.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports